import { render, staticRenderFns } from "./CheckDiscountIntegral.vue?vue&type=template&id=319e5242&scoped=true&"
import script from "./CheckDiscountIntegral.vue?vue&type=script&lang=js&"
export * from "./CheckDiscountIntegral.vue?vue&type=script&lang=js&"
import style0 from "./CheckDiscountIntegral.vue?vue&type=style&index=0&id=319e5242&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319e5242",
  null
  
)

export default component.exports